import { type MaintenanceChecklistDefinition } from '@gb-ticket/shared-types';

import { ChecklistFieldView } from '@/products/maintenance/features/protocol-renderer/checklist-field-view';

type Props = {
  definition: MaintenanceChecklistDefinition;
};

export function ChecklistPreview({ definition }: Props) {
  if (definition.sections.length === 0) {
    return <p className="text-sm text-muted-foreground">Noch keine Abschnitte definiert.</p>;
  }

  return (
    <div className="space-y-6">
      {definition.sections
        .slice()
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((section) => (
          <section key={section.id} className="space-y-3 rounded-md border p-4">
            <h3 className="text-base font-semibold">{section.title}</h3>
            <div className="grid gap-4">
              {section.fields
                .slice()
                .sort((a, b) => a.sortOrder - b.sortOrder)
                .map((field) => (
                  <ChecklistFieldView key={field.fieldKey} field={field} readOnly />
                ))}
            </div>
          </section>
        ))}
    </div>
  );
}
